import { getSessionLoader } from '../../platform/identifiers';
const sessionDataLoader = getSessionLoader();
export function getAlmeSessionData() {
    let almeSessionData;
    try {
        almeSessionData = sessionDataLoader.GetAlmeSessionData();
    }
    catch (ex) {
        console.error(ex);
    }
    return almeSessionData;
}
